export default "__VITE_ASSET__CSYELsFd__"